import * as _ from "lodash";

export class Campaign {
    public readonly requestIgnoreList = ["localStorageService"];
    private localStorageService: any;
    private $q: any;

    public canvassingType: any;
    public localInfo: any = null;
    public campaigntype: string | null = null;
    public campaignid: string;
    /** AV-17963: the region's home account, which admins cannot leave. */
    public adminhome?: boolean;
    // AV-17974: Xero link columns from the admin list query
    public xero_status?: string | null;
    public xero_contact_id?: string | null;
    public xero_name?: string | null;
    public xero_outstanding?: string | null;
    public xero_overdue?: string | null;
    public xero_currency?: string | null;
    public xero_contact_status?: string | null;
    public cpinterval?: any;
    public campaignstatusid?: any;
    public member?: any;
    public campaignname?: string;
    public campaignstatusname?: string;
    public subscriptionid?: string;
    public campaignexpire?: any;
    public organisation?: any;
    public oid?: any;
    public limits?: any;
    public campaignregion?: string;
    public campaigncreationdatetime?: any;
    public datarecordversion?: any;
    public trial_days?: any;
    public trial_days_rounded?: any;
    public campaignlimits?: any;
    public plan?: any;
    public cpid?: any;
    public permissionid?: any;
    public setupComplete?: any;
    public selected?: any;
    public disabled?: any;
    public slug?: string;
    public nbnid?: any;
    public type?: string;
    public name?: string;
    public color?: string;
    public campaigncolor?: string;
    public checked?: any;
    public relationships?: any;
    public cpcountry?: any;
    public attributes?: any;
    public campaigncreator?: any;
    public campaignowner?: any;
    public subscriptionstatus?: any;
    public redirect?: any;
    public cpname?: any;
    public cpprice?: any;
    public campaigntimestamp?: any;
    public exists?: any;
    public features?: any;
    public campaignkind?: any;
    public campaign_kind_category?: string;
    public campaign_kind_subcategory?: string;
    public langcode?: string;

    constructor(localStorageService: any, $q: any, data?: any) {
        this.localStorageService = localStorageService;
        this.$q = $q;

        if (data) {
            this.setData(data);
        }

        this.canvassingType = null;
    }

    setData(data: any): void {
        data.localStorageService = this.localStorageService;
        data.$q = this.$q;
        _.merge(this, data);
    }

    getLocalStorage(): any {
        if (this.localStorageService.isSupported && this.campaignid) {
            let campaigninfo = this.localStorageService.get(this.campaignid);
            if (!!campaigninfo && campaigninfo !== "null")
                this.localInfo = campaigninfo;
            else this.localInfo = {};
        } else {
            this.localInfo = {};
        }
        return this.localInfo;
    }

    saveLocalStorage(): void {
        if (this.localStorageService.isSupported && this.localInfo) {
            this.localStorageService.set(this.campaignid, this.localInfo);
        }
    }

    getCampaignCanvassingType(): Promise<object> {
        const deferred = this.$q.defer();

        let canvassingTypes = [
            { ctid: "1", ctname: "Walk" },
            { ctid: "2", ctname: "Go" },
        ];

        deferred.resolve(canvassingTypes);

        return deferred.promise;
    }

    setSelectedEffort(effortId: string): void {
        if (this.localInfo) {
            this.localInfo.effort = effortId;
            this.saveLocalStorage();
        }
    }

    getSelectedEffort(): any {
        if (!this.localInfo || this.localInfo === "null") {
            this.getLocalStorage();
        }
        return this.localInfo.effort || null;
    }

    isOrganisationCampaign(): boolean {
        return this.campaigntype === "ORGANISATION";
    }

    inEssentialsMode(): boolean {
        return this.campaignstatusid == "5";
    }

    paymentFailed(): boolean {
        return (
            !this.oid &&
            this.cpid &&
            this.subscriptionstatus != null &&
            this.subscriptionstatus != "active" &&
            this.subscriptionstatus != "trialing"
        );
    }

    essentialsModeAvailable(uid: string | number): boolean {
        return (
            this.campaign_kind_category &&
            this.campaign_kind_category.toLowerCase().includes("political") &&
            this.campaignowner == uid &&
            this.campaignstatusid == "1" &&
            this.subscriptionid != null &&
            this.subscriptionid != ""
        );
    }

    inTrialMode(): boolean {
        return this.campaignstatusid === "2";
    }
}
